// src/App.tsx
import { Route, Routes } from 'react-router-dom';
import ChatbotPage from './pages/ChatbotPage';
// import DashboardPage from './pages/DashboardPage';
import HomePage from './pages/HomePage';
import Header from './components/Header';
import GroupManagerPage from './pages/GroupManagerPage';
import '@aws-amplify/ui-react/styles.css';
import QBusinessPage from './pages/QBusinessPage';
import ContactUsPage from './pages/ContactUsPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzerklaerungPage from './pages/DatenschutzerklaerungPage';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import allRoutes from './lib/routes';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/navigation" element={<Header />} />
        <Route path="/login" element={<Login />} />
        <Route
          path={allRoutes.chatbot.route}
          element={
            <ProtectedRoute accessControl="chatbot">
              <>
                <Header>
                  <ChatbotPage />
                </Header>
              </>
            </ProtectedRoute>
          }
        />
        {/* <Route
            path={allRoutes.dashboard.route}
            element={
              <ProtectedRoute>
                <>
                  <Header />
                  <DashboardPage />
                </>
              </ProtectedRoute>
            }
          /> */}

        {/* <Route
          path={allRoutes.qbusiness.route}
          element={
            <ProtectedRoute accessControl="qbusiness">
              <>
                <Header>
                  <QBusinessPage />
                </Header>
              </>
            </ProtectedRoute>
          }
        /> */}
        <Route
          path={allRoutes.groupManager.route}
          element={
            <ProtectedRoute adminRoute>
              <>
                <Header>
                  <GroupManagerPage />
                </Header>
              </>
            </ProtectedRoute>
          }
        />
        <Route path={allRoutes.contact.route} element={<ContactUsPage />} />
        <Route path={allRoutes.impressum.route} element={<ImpressumPage />} />
        <Route path={allRoutes.datenschutzerklaerung.route} element={<DatenschutzerklaerungPage />} />
      </Routes>
    </>
  );
}

export default App;
